import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL, AUTH_JWT, AUTH_PARTNER_INTEGRATION } from "@config/config";

const fetchWhiteLabel = async (subscriberGroupId) => {
    const res = await axios.get(`${API_BASE_URL}/subscriber-group-white-label/${subscriberGroupId}`);
    return res?.data?.data?.white_label ?? null;
};

export const useWhiteLabel = (subscriberGroupId) => {
    const { data, isLoading } = useQuery({
        queryKey: ["whiteLabel", subscriberGroupId],
        queryFn: () => fetchWhiteLabel(subscriberGroupId),
        enabled: !!subscriberGroupId,
        staleTime: Infinity,
    });

    const appSecurityLogIn =
        !!data &&
        data?.subscriber_group?.authentication_type !== AUTH_JWT &&
        data?.subscriber_group?.authentication_type !== AUTH_PARTNER_INTEGRATION;

    return {
        whiteLabel: data ?? null,
        isLoading,
        appSecurityLogIn,
    };
};
